var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 178,
    viewBox: "0 0 513 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.78 137.24H483.36C481.634 114.971 463.189 97.4474 440.701 97.4474C426.744 97.4474 414.414 104.225 406.622 114.633C400.754 108.533 392.567 104.709 383.542 104.709C383.246 104.709 382.999 104.709 382.703 104.709C378.462 79.536 356.762 60.3176 330.624 60.3176C316.223 60.3176 303.204 66.1267 293.636 75.5665C272.43 30.885 227.205 0 174.83 0C102.136 0 43.1528 59.5431 43.1528 132.98C43.1528 134.383 43.1528 135.787 43.2514 137.143H20.2201C9.07441 137.143 0 146.34 0 157.571C0 168.802 9.12373 178 20.2201 178H492.78C503.926 178 513 168.802 513 157.571C513 146.34 503.876 137.143 492.78 137.143V137.24Z",
    fill: "url(#paint0_linear_728_3011)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.78 137.24H483.36C481.634 114.971 463.189 97.4474 440.701 97.4474C426.744 97.4474 414.414 104.225 406.622 114.633C400.754 108.533 392.567 104.709 383.542 104.709C383.246 104.709 382.999 104.709 382.703 104.709C378.462 79.536 356.762 60.3176 330.624 60.3176C316.223 60.3176 303.204 66.1267 293.636 75.5665C272.43 30.885 227.205 0 174.83 0C102.136 0 43.1528 59.5431 43.1528 132.98C43.1528 134.383 43.1528 135.787 43.2514 137.143H20.2201C9.07441 137.143 0 146.34 0 157.571C0 168.802 9.12373 178 20.2201 178H492.78C503.926 178 513 168.802 513 157.571C513 146.34 503.876 137.143 492.78 137.143V137.24Z",
    fill: "url(#paint1_linear_728_3011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_728_3011",
    x1: 257.01,
    y1: -0.0000395572,
    x2: 257.01,
    y2: 512.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE90D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDCB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_728_3011",
    x1: 256.5,
    y1: 0,
    x2: 256.5,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEF8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEF8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLCloud);
export default __webpack_public_path__ + "static/media/l-cloud.370bea997695e00dec512927c7914245.svg";
export { ForwardRef as ReactComponent };